var _path, _path2, _g, _path3, _path4, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.997 5.1 16 10.68v.245c0 2.687-1.63 4.276-4.386 4.276H4.387C1.629 15.2 0 13.61 0 10.924V5.07C0 2.383 1.63.8 4.387.8h7.224c2.757 0 4.386 1.583 4.386 4.27v.03z",
    fill: "url(#vjd5amyhea)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ext4k5m62b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.997 5.1 16 10.68v.245c0 2.687-1.63 4.276-4.386 4.276H4.387C1.629 15.2 0 13.61 0 10.924V5.07C0 2.383 1.63.8 4.387.8h7.224c2.757 0 4.386 1.583 4.386 4.27v.03z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ext4k5m62b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#axj3e28hmc)",
    d: "M0 .8h16v14.4H0z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97 12.35c0 .2.151.342.344.342a.334.334 0 0 0 .343-.343v-.645c1.356-.1 2.352-.895 2.352-2.109 0-1.105-.72-1.766-2.176-2.059l-.176-.033V4.94c.728.092 1.247.51 1.398 1.139.067.226.192.36.427.36.234 0 .401-.168.401-.41 0-.084-.016-.168-.033-.243-.21-.904-1.08-1.549-2.193-1.65v-.594c0-.2-.15-.343-.343-.343-.201 0-.344.134-.344.343v.595c-1.264.117-2.201.912-2.201 2.034 0 1.03.711 1.657 2.118 1.992l.083.017v2.728c-.853-.092-1.414-.586-1.54-1.247-.067-.243-.209-.368-.427-.368-.234 0-.401.167-.401.418 0 .084.016.168.033.243.226.988 1.164 1.65 2.335 1.741v.653zm.002-5.023V4.94c-.795.1-1.348.586-1.348 1.197 0 .578.419.938 1.298 1.172l.05.017zm.687 3.582c.962-.075 1.506-.594 1.506-1.28 0-.611-.368-.988-1.322-1.23l-.184-.051v2.561z",
    fill: "url(#nx9nun373d)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "95m9xyeohe",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 3,
    width: 7,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97 12.35c0 .2.151.342.344.342a.334.334 0 0 0 .343-.343v-.645c1.356-.1 2.352-.895 2.352-2.109 0-1.105-.72-1.766-2.176-2.059l-.176-.033V4.94c.728.092 1.247.51 1.398 1.139.067.226.192.36.427.36.234 0 .401-.168.401-.41 0-.084-.016-.168-.033-.243-.21-.904-1.08-1.549-2.193-1.65v-.594c0-.2-.15-.343-.343-.343-.201 0-.344.134-.344.343v.595c-1.264.117-2.201.912-2.201 2.034 0 1.03.711 1.657 2.118 1.992l.083.017v2.728c-.853-.092-1.414-.586-1.54-1.247-.067-.243-.209-.368-.427-.368-.234 0-.401.167-.401.418 0 .084.016.168.033.243.226.988 1.164 1.65 2.335 1.741v.653zm.002-5.023V4.94c-.795.1-1.348.586-1.348 1.197 0 .578.419.938 1.298 1.172l.05.017zm.687 3.582c.962-.075 1.506-.594 1.506-1.28 0-.611-.368-.988-1.322-1.23l-.184-.051v2.561z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#95m9xyeohe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ix26m0eslf)",
    d: "M5.602 3.2h5.6v9.6h-5.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vjd5amyhea",
    x1: 0,
    y1: 0.8,
    x2: 0,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "axj3e28hmc",
    x1: 0,
    y1: 0.8,
    x2: 0,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nx9nun373d",
    x1: 5.602,
    y1: 3.2,
    x2: 5.602,
    y2: 12.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ix26m0eslf",
    x1: 5.602,
    y1: 3.2,
    x2: 5.602,
    y2: 12.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCash);
export default __webpack_public_path__ + "static/media/ic-cash.b3741420.svg";
export { ForwardRef as ReactComponent };